module.exports = __webpack_public_path__ + "d48f0138f19ae12dbf48f6057a7d59c9.png";